import { render, staticRenderFns } from "./PresupuestoLineaNominas.vue?vue&type=template&id=b138a472&scoped=true"
import script from "./PresupuestoLineaNominas.vue?vue&type=script&lang=js"
export * from "./PresupuestoLineaNominas.vue?vue&type=script&lang=js"
import style0 from "./PresupuestoLineaNominas.vue?vue&type=style&index=0&id=b138a472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b138a472",
  null
  
)

export default component.exports